import Helper from './Helper';
import HeaderStateHandler from './HeaderStateHandler';

class ShareHandler {
  constructor() {
    this.toggler = this.constructor.getToggler();
    this.share = this.constructor.getShare();
    this.shareOpen = false;
    let title = document.querySelector('title');
    if(title){
      this.title = title.innerText;
    }
    this.url = window.location.href;
    this.image = '';
    if(this.toggler){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.toggler.addEventListener('click', () => {
      this.togglerClicked();
    });
    document.querySelector('#js-share-facebook').addEventListener('click', () => {
      this.shareFacebook();
    });
    document.querySelector('#js-share-twitter').addEventListener('click', () => {
      this.shareTwitter();
    });
    document.querySelector('#js-share-linkedin').addEventListener('click', () => {
      this.shareLinkedin();
    });
    // document.querySelector('#js-share-mail').addEventListener('click', () => {
      // this.shareMail();
    // });

  }

  closeShare(){
    Helper.slideClose(this.share);
    Helper.removeClass(this.toggler, 'active');
  }

  static closeShare(){
    Helper.slideClose(this.getShare());
    Helper.removeClass(this.getToggler(), 'active');
  }

  openShare(){
    HeaderStateHandler.shareHandler();
    Helper.slideOpen(this.share);
    Helper.addClass(this.toggler, 'active');
    this.shareOpen = true;
  }

  togglerClicked(){
    if(this.constructor.isShareOpen()){
      this.constructor.closeShare();
    } else {
      this.openShare();
    }
  }

  shareTwitter() {
    window.open('http://twitter.com/share?url=' + this.url + '&text=' + this.title, 'tshare', 'height=400,width=550,resizable=1,toolbar=0,menubar=0,status=0,location=0');
  }

  shareFacebook() {
    window.open('http://facebook.com/sharer.php?s=100&p[url]=' + this.url + '&p[images][0]=' + this.image + '&p[title]=' + this.title, 'fbshare', 'height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0');
  }

  shareLinkedin(){
    window.open('http://www.linkedin.com/shareArticle?mini=true&title='+this.title+'url='+encodeURIComponent(this.url), '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
  }

  shareMail(){
    window.location.href = 'mailto:?subject='+this.title+'&body='+this.url;
  }


  static getToggler(){
    return document.querySelector('#js-share-toggler');
  }

  static getShare(){
    return document.querySelector('#js-header-share');
  }

  static isShareOpen(){
    return Helper.hasClass(this.getToggler(), 'active');
  }

} export default ShareHandler;
